import React from 'react'
import Home from './pages/Home';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import FAQ from './pages/FAQ';
import Safety from './pages/Safety';

import { Switch, Route } from 'react-router-dom';

const Main = () => {
    return (
    <Switch>
      <Route exact path='/' component={Home}></Route>
      <Route exact path='/Shop' component={Shop}></Route>
      <Route exact path='/FAQ' component={FAQ}></Route>
      <Route exact path='/Safety' component={Safety}></Route>
      <Route exact path='/Contact' component={Contact}></Route>
    </Switch>
    )
}

export default Main
